import { render, staticRenderFns } from "./ValidatorReward.vue?vue&type=template&id=016527c2&scoped=true&"
import script from "./ValidatorReward.vue?vue&type=script&lang=ts&"
export * from "./ValidatorReward.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorReward.vue?vue&type=style&index=0&id=016527c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016527c2",
  null
  
)

export default component.exports